<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit Task</h3>
				</div>
			</div>
			<Form :task="task" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'task'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Tasks/Edit.vue